import { connect } from 'react-redux';

import {
  getMainBranch,
  getIsBranchListLoading,
  getAllBranches,
  getIsBranchListError,
  getSelectedBranches,
  onToggleBranchSelect,
  onToggleBranchSelectAllInPage,
  getIsInSelectionMode,
  getBranchingModel,
} from 'src/redux/branches';
import { BucketState } from 'src/types/state';

import ListOfBranches from '../components/branch-list-with-keyboard-shortcuts';

const mapStateToProps = (state: BucketState) => {
  const mainBranch = getMainBranch(state);
  const branches = getAllBranches(state);
  const isLoading = getIsBranchListLoading(state);
  const isError = getIsBranchListError(state);
  const selectedBranches = getSelectedBranches(state);
  const isInSelectionMode = getIsInSelectionMode(state);
  const branchingModel = getBranchingModel(state);

  return {
    isLoading,
    mainBranch,
    isError,
    branches,
    selectedBranches,
    isInSelectionMode,
    branchingModel,
  };
};

const mapDispatchToProps = {
  onToggleBranchSelect,
  onToggleBranchSelectAllInPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(ListOfBranches);
